import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 10,
  fill: "#E0F2E4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#088E29",
  fillRule: "evenodd",
  d: "M12.748 14.394a.75.75 0 0 1-.498-.707V3.53a9.5 9.5 0 1 0 9.131 13.948zm9.235 1.705A9.5 9.5 0 0 0 22.5 13c0-1.854-.53-3.583-1.449-5.045l-6.562 5.468zm-8.233-4.013 6.404-5.337a9.48 9.48 0 0 0-6.404-3.22zM13 24c6.075 0 11-4.925 11-11S19.075 2 13 2 2 6.925 2 13s4.925 11 11 11",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=DashboardsColorIcon26.js.map